import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlotInlineRadioButtonComponent } from '../slot-inline-radio-button/slot-inline-radio-button.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { DelayDisplayImpurePipe, SlotTooltipPipe, TranslationKeyPipe } from '../../../pipes';
import { LayoutDirective } from '../../../directives';
import { ComponentsModule } from '../../../../../lib';
import { VisualComponent } from '../../visual/visual.component';

@Component({
    selector: 'ca-slot-tile-radio-button',
    imports: [
        CommonModule,
        LayoutDirective,
        MatRadioModule,
        ComponentsModule,
        TranslationKeyPipe,
        SlotTooltipPipe,
        DelayDisplayImpurePipe,
        VisualComponent
    ],
    templateUrl: './slot-tile-radio-button.component.html',
    styleUrl: './slot-tile-radio-button.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotTileRadioButtonComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlotTileRadioButtonComponent extends SlotInlineRadioButtonComponent {}
